/* PeopleField's words (the Anatomy board's words table is binding). One set
   for every module: a place passes its noun ("this VSM") and its role names
   through the PeopleSource, never through these. Every entry can be
   overridden through `labels`. */

export const PEOPLE_FIELD_LABELS = {
  /** The read-only field with nobody assigned. */
  unassigned: "Unassigned",
  /** The trigger's name while empty: "Assign person as Owner". */
  openName: (emptyLabel: string, label: string) => `${emptyLabel} as ${label}`,
  /** The chip's name: "Change Owner: Daniel Okafor". */
  changeName: (label: string, name: string) => `Change ${label}: ${name}`,
  /** The ×: "Remove Daniel Okafor as Owner". */
  removeName: (label: string, name: string) => `Remove ${name} as ${label}`,
  dialogName: (label: string) => `${label}: choose a person`,
  searchPlaceholder: "Search people in your workspace",
  assignToMe: "Assign to me",
  you: "(you)",
  withAccess: "People with access",
  inNoun: (noun: string) => `In ${noun}`,
  notInNoun: (noun: string) => `Not in ${noun}`,
  workspace: "People in your workspace",
  /** Before the search runs: how many more letters it needs. */
  hint: (remaining: number, typed: boolean) =>
    typed
      ? `Type ${remaining} more ${remaining === 1 ? "letter" : "letters"} to search everyone in your workspace.`
      : `Type ${remaining} letters to search everyone in your workspace.`,
  searching: "Searching your workspace",
  searchingCount: "Searching…",
  searchFailed: "Couldn’t search your workspace right now.",
  /** Follows `searchFailed` where a roster still shows. */
  searchFailedRoster: "People with access still show.",
  retry: "Retry",
  noResults: (query: string) => `No one matches “${query}”.`,
  noResultsHint: "Check the spelling, or search by email.",
  loadMore: "Load more",
  loadingMore: "Loading more…",
  loadMoreFailed: "Couldn’t load more. Try again",
  typedName: (query: string) => `Use “${query}” as a name`,
  typedDetail: "Not linked to a person · no access change",
  notLinked: "Not linked",
  noAccess: "No access",
  notActive: "Not active",
  pendingGrant: (role: string) => `Gets ${role} on save`,
  grantNow: (role: string) => `No access · Will be added as ${role}`,
  grantSave: (role: string) => `No access · Gets ${role} access when you save`,
  grantSend: (role: string) => `No access · Gets ${role} access when you send`,
  greyed: (whoCanAdd: string) => `No access · ${whoCanAdd}`,
  alreadyHasAccess: "Already has access",
  shareGrant: (role: string) => `Gets ${role} access`,
  keyMove: "move",
  keyPick: "pick",
  keyClose: "close",
};

export type PeopleFieldResolvedLabels = typeof PEOPLE_FIELD_LABELS;

/** Copy overrides for `PeopleField`; anything left out keeps the default. */
export type PeopleFieldLabels = Partial<PeopleFieldResolvedLabels>;
